// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__V06q5","spin":"Spinner_spin__Dfcyj"};